import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {ILink} from '@wix/wixstores-client-core';
import {PaymentRequestState} from '../../../types/paymentRequestApp.types';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {SPECS} from '../../../common/constants';

export class PaymentRequestNavigationService {
  private readonly siteStore: SiteStore;
  private readonly controllerConfig: IWidgetControllerConfig;
  private readonly viewerContext: ViewerContext;
  private continueShoppingLink!: ILink;
  private fetchedContinueShoppingUrl!: string;
  public paymentRequestState: PaymentRequestState = PaymentRequestState.unpaid;
  private readonly url: URL;

  constructor({
    siteStore,
    controllerConfig,
    viewerContext,
  }: {
    controllerConfig: IWidgetControllerConfig;
    siteStore: SiteStore;
    viewerContext: ViewerContext;
  }) {
    this.siteStore = siteStore;
    this.controllerConfig = controllerConfig;
    this.viewerContext = viewerContext;
    const moveCheckoutToViewerContext = this.viewerContext.isExperimentEnabled(SPECS.MoveCheckoutToViewerContext);
    this.url = new URL(
      moveCheckoutToViewerContext ? this.controllerConfig.wixCodeApi.location.url : this.siteStore.location.url
    );
  }

  public async load() {
    if (this.viewerContext.isExperimentEnabled(SPECS.MoveCheckoutToViewerContext)) {
      this.fetchedContinueShoppingUrl = this.fetchContinueShoppingUrl();
    } else {
      this.continueShoppingLink = await this.fetchContinueShoppingLink();
    }
  }

  public setPaymentRequestState(state: PaymentRequestState) {
    this.paymentRequestState = state;
  }

  private async fetchContinueShoppingLink(): Promise<ILink> {
    return this.siteStore.getHomepageLink();
  }

  private fetchContinueShoppingUrl(): string {
    return this.viewerContext.getHomepageUrl();
  }

  public get continueShoppingUrl() {
    return this.viewerContext.isExperimentEnabled(SPECS.MoveCheckoutToViewerContext)
      ? this.fetchedContinueShoppingUrl
      : this.continueShoppingLink.url;
  }

  public get redirectErrorState(): boolean {
    return this.url.searchParams.get('redirect') === 'error';
  }

  public get paymentMethodName(): string {
    return this.url.searchParams.get('pmName') || '';
  }
}
